import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import './App.css';  // Import the CSS file
import logo from './logo.png';

// Helper function to decode Base64 string
function decodeBase64(encoded) {
    const decodedURIComponent = decodeURIComponent(encoded); // step 1
    const decodedString = atob(decodedURIComponent); // step 2

    const parts = decodedString.split('|').filter(Boolean); // split on "|"

    return parts;
}



// React component
const ApprovalPage = () => {
    const query = new URLSearchParams(useLocation().search); // Get the 'data' param
    const [clientName, setClientName] = useState('');
    const [email, setEmail] = useState('');
    const [filename, setFilename] = useState('');
    const [remark, setRemark] = useState('');
    const [processServer , setProcessServer] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [errorText, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [approverName, setApproverName] = useState('');
    const [status, setStatus] = useState('');
    const [timeStamp, setTimeStamp] = useState('');
    const [dataMessage, setDataMessage] = useState('');

    useEffect(() => {
        console.log("useEffect triggered");
        console.log("Current query:", query);
        const encodedData = query.get('data');
        console.log("raw data :" + encodedData);
        
        if (encodedData) {
            const decodedArray = decodeBase64(encodedData);
            const clientName = decodedArray[0] || '';
            const email = decodedArray[1] || '';
            const filename = decodedArray[2] || '';
            const ip = decodedArray[3] || '';

            setClientName(clientName || '');
            setEmail(email || '');
            setFilename(filename || '');
            setProcessServer(ip || '');
        
            if (filename) {
                 fetchStatus(filename,ip);
            }

            console.log("Extracted values:", { clientName, email, filename, ip });
        }
    }, []);
    

    //get status of current filename the moment browser is loading
    const fetchStatus = async (filename,processIp) => {
        setLoading(true)
        try {
            const response = await fetch(`https://ssm.pnmb.com.my/API/api/Approval/get-data/${filename}?serverIp=${processIp}`);
            
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
        
            const data = await response.json();
            console.log('Response data:', data); // Log the response data

            setStatus(data.status);
            setApproverName(data.approverName);
            setTimeStamp(data.approverTime);
            setDataMessage(data.message);
            setLoading(false); // Hide loading screen
        
            //setStatus(data); // Set the fetched status in the state
          } catch (error) {
            console.error('Error fetching status:', error);
            alert('Error fetching status. Please Contact PNMB PIC regarding this matter');
          }
    };

    //approve button
    const handleApproval = async (isApproved) => {
        setLoading(true);
        try {
            const response = await fetch('https://ssm.pnmb.com.my/API/api/Approval/submit-approval', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    clientName: clientName,
                    email: email,
                    isApproved: isApproved,
                    filename: filename,
                    message: remark,
                    serverProcess : processServer
                }),
            });

            if (!response.ok) {
                const errorText = await response.text();
                console.error('Server response error:', errorText);
                alert(`Server Error, Please Contact PNMB PIC: ${response.status} - ${errorText}`);
            } else {
                const successText = await response.text();
                alert('approval '+ isApproved +' submitted:');
            }
            setLoading(false);
            window.location.reload(); // This will refresh the page
        } catch (error) {
            console.error('Network error:', error);
            alert('Network error, Please Contact PNMB PIC : ' + error.message);
        }
        
    };

    //Reject submit, 
    const handleDisapproveSubmit_Submit = () => {
        if (!remark.trim()) {
            setError('Please enter a reason for rejection.');
            return; // Prevent submission if remark is empty
        }
    
        setError(''); // Clear error if validation passes
        setShowModal(false);
        handleApproval(false); //i used same approval function to send data to server.js
    };

    const handleDisapproveSubmit_Cancel = () => {
        setError(''); // Clear error if user close modal
        setRemark('');
        setShowModal(false);
    };

    return (
        <div className="main-container">
            {/* Header */}
            <div className="header">
                <img src={logo} alt="Logo" />
                <h1>SSM: APPROVAL SUBMISSION</h1>
            </div>

            {/* Main content */}
            <div className="main-content">
                <table className="info-table">
                    <tbody>
                        <tr>
                            <th>Client Name</th>
                            <td>{clientName}</td>
                        </tr>
                        <tr>
                            <th>Email</th>
                            <td>{email}</td>
                        </tr>
                        <tr>
                            <th>Filename</th>
                            <td>{filename}</td>
                        </tr>
                        <tr>
                            <th>File Status</th>
                            <td className={status === 'Rejected' ? 'text-danger' : status === 'Approved' ? 'text-success' : ''}>
                                {status}
                            </td>
                        </tr>
                        {/* Conditionally display Approver Name and Date/Time Approved */}
                        {status === 'Approved' && (
                            <>
                                <tr>
                                    <th>Approver Name</th>
                                    <td>{approverName}</td>
                                </tr>
                                <tr>
                                    <th>Date/Time Approved</th>
                                    <td>{new Date(timeStamp).toLocaleString()}</td>
                                </tr>
                            </>
                        )}
                        {/* Additional handling for Rejected status if needed */}
                        {status === 'Rejected' && (
                            <>
                                <tr>
                                    <th>Approver Name</th>
                                    <td>{approverName}</td>
                                </tr>
                                <tr>
                                    <th>Reason</th>
                                    <td className="expandable-cell">{dataMessage}</td>
                                </tr>
                                <tr>
                                    <th>Date/Time Rejected</th>
                                    <td>{new Date(timeStamp).toLocaleString()}</td>
                                </tr>
                            </>
                        )}
                    </tbody>
                </table>
                
                {/* Conditionally render the button container based on status */}
                {status !== 'Approved' && status !== 'Rejected' && (
                    <div className="button-container">
                        <Button variant="success" onClick={() => handleApproval(true)} disabled={loading}>
                            Approve
                        </Button>
                        <Button variant="danger" onClick={() => setShowModal(true)} disabled={loading}>
                            Reject
                        </Button>
                    </div>
                )}
            </div>

            {/* Footer */}
            <div className="footer">
                <p>&copy; {new Date().getFullYear()} Percetakan Nasional Malaysia Berhad. All rights reserved.</p>
            </div>

            {/* Loading screen */}
            {loading && (
                <div className="loading-overlay">
                    <Spinner animation="border" />
                    <p>Loading...</p>
                </div>
            )}

            {/* Modal for disapproval */}
            <Modal
                show={showModal}
                onHide={handleDisapproveSubmit_Cancel}
                dialogClassName="modal-dialog-centered"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Submission for Rejection</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Filename: {filename}</p>
                    <p>Rejected by: {clientName}</p>
                    <Form.Group controlId="formRemark">
                    <Form.Label>Reason:</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        value={remark}
                        onChange={(e) => setRemark(e.target.value)}
                        placeholder="Enter reason for rejection"
                        maxLength={200} // Limit to 50 characters
                        required
                    />
                    <Form.Text className="text-muted">
                        {remark.length}/200 characters
                    </Form.Text>
                </Form.Group>
                    <p className='text-danger'>{errorText}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleDisapproveSubmit_Cancel}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDisapproveSubmit_Submit} disabled={loading}>
                        {loading ? <Spinner animation="border" size="sm" /> : 'Submit Rejection'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ApprovalPage;
